import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';

@Directive({
  selector: '[dbClassChangeObserver]',
  standalone: true
})
export class ClassChangeObserverDirective implements OnInit, OnDestroy {
  private observer: MutationObserver;
  @Output() classChanged: EventEmitter<HTMLElement> = new EventEmitter<HTMLElement>();

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          this.classChanged.emit(this.el.nativeElement);
        }
      }
    });
    this.observer.observe(this.el.nativeElement, {attributes: true});
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
